import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getMorePosts = createAsyncThunk(
  "posts/fetchMorePosts",
  async (after) => {
    const res = await fetch(
      `https://www.reddit.com/r/pics.json?after=${after}`
    );
    const resJson = await res.json();
    return resJson;
  }
);

export const getPosts = createAsyncThunk(
  "posts/fetchPosts",
  async (subreddit) => {
    const url = `https://www.reddit.com/${subreddit}.json`;
    const res = await fetch(url);
    const resJson = await res.json();
    return resJson;
  }
);

const initialState = {
  posts: [],
  after: "",
  error: false,
  isLoading: true,
};

const options = {
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: {
    [getMorePosts.pending]: (state, action) => {
      state.error = false;
      state.isLoading = true;
    },
    [getMorePosts.fulfilled]: (state, action) => {
      state.error = false;
      state.isLoading = false;
      state.posts.push(action.payload);
      state.after = action.payload.data.after;
    },
    [getMorePosts.rejected]: (state, action) => {
      state.error = true;
      state.isLoading = false;
    },
    [getPosts.pending]: (state, action) => {
      state.error = false;
      state.isLoading = true;
    },
    [getPosts.fulfilled]: (state, action) => {
      state.error = false;
      state.isLoading = false;
      state.posts = [action.payload];
      state.after = action.payload.after;
    },
    [getPosts.rejected]: (state, action) => {
      state.error = true;
      state.isLoading = false;
    },
  },
};

const postsSlice = createSlice(options);
export default postsSlice.reducer;
export const selectPosts = (state) => state.posts.posts;
export const selectAfter = (state) => state.posts.after;
